var _ellipse, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 211,
    viewBox: "0 0 288 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144,
    cy: 175,
    rx: 110,
    ry: 12,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.479 95.141C172.235 98.9771 192.981 84.4504 196.817 62.6946C200.653 40.9389 186.126 20.1925 164.371 16.3564C142.615 12.5203 121.869 27.047 118.032 48.8028C114.196 70.5585 128.723 91.3049 150.479 95.141Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1677 137.026C86.0039 115.271 106.75 100.744 128.506 104.58L167.898 111.526C189.654 115.362 204.181 136.108 200.345 157.864L199.959 160.053C198.254 169.722 189.033 176.178 179.364 174.473L96.2024 159.81C86.5332 158.105 80.0769 148.884 81.7818 139.215L82.1677 137.026Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.479 95.141C172.235 98.9771 192.981 84.4504 196.817 62.6946C200.653 40.9389 186.126 20.1925 164.371 16.3564C142.615 12.5203 121.869 27.047 118.032 48.8028C114.196 70.5585 128.723 91.3049 150.479 95.141Z",
    stroke: "#BDBAB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1677 137.026C86.0039 115.271 106.75 100.744 128.506 104.58L167.898 111.526C189.654 115.362 204.181 136.108 200.345 157.864L199.959 160.053C198.254 169.722 189.033 176.178 179.364 174.473L96.2024 159.81C86.5332 158.105 80.0769 148.884 81.7818 139.215L82.1677 137.026Z",
    stroke: "#BDBAB4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyuser);
export default __webpack_public_path__ + "static/media/Empty user.6467233e7df378cd2a0b7292eaf65221.svg";
export { ForwardRef as ReactComponent };